export default "__VITE_ASSET__8wj$5wyp__"